import React, { useEffect, useState } from 'react';
import api from 'api';
import { isMobileAppRuntime } from 'utils';
import { getNativeStorePlatform } from 'mobile-modules/native-billing/nativeBilling';
import { recoverMobilePurchases } from './mobilePurchaseFlow';
import MobilePurchasePanel from './MobilePurchasePanel';

const CACHE_KEY = 'flc.mobile.purchase.status.v1';
const readCache = () => {
  try { return JSON.parse(window.localStorage.getItem(CACHE_KEY) || 'null'); } catch (_) { return null; }
};
const writeCache = status => {
  try { window.localStorage.setItem(CACHE_KEY, JSON.stringify(status)); } catch (_) {}
};

const isNativeBillingRuntime = () => isMobileAppRuntime() && ['apple', 'google'].includes(getNativeStorePlatform());

const MobilePurchaseAccessGate = ({ children, translate }) => {
  const [status, setStatus] = useState(() => (isNativeBillingRuntime() ? readCache() : null));
  const [checked, setChecked] = useState(!isNativeBillingRuntime());

  useEffect(() => {
    if (!isNativeBillingRuntime()) return undefined;
    let active = true;

    const bootstrap = async () => {
      try {
        const serverStatus = await api.mobileRuntime.getPurchaseStatus();
        const recovery = await recoverMobilePurchases(serverStatus);
        if (!active) return;
        const next = recovery.status || serverStatus;
        setStatus(next);
        writeCache(next);
        setChecked(true);

        // A recovered Custom Level must be bootstrapped by FlinkPlay from the new
        // generated record. Reload once after Play has been consumed successfully.
        if (recovery.recovered > 0 && next?.purchaseProductType === 'custom_content') {
          window.location.reload();
        }
      } catch (error) {
        if (!active) return;
        console.warn('[mobile-purchase] entitlement bootstrap skipped', error?.message || error);
        setChecked(true);
      }
    };

    bootstrap();
    return () => { active = false; };
  }, []);

  if (!isNativeBillingRuntime()) return children;
  if (!checked && !status) return null;
  if (status?.requiresRenewal) {
    return <MobilePurchasePanel translate={translate} initialStatus={status} onStatusChange={next => { setStatus(next); writeCache(next); }} />;
  }
  return children;
};

export default MobilePurchaseAccessGate;
